import { DEFAULT_PAGE_SIZE } from '@flux/shared';
import { Link } from '@tanstack/react-router';
import { Download } from 'lucide-react';
import type { JSX } from 'react';
import { Button } from '@/components/ui/button.js';
import { downloadFromApi } from '@/lib/api/client.js';
import { OperationHistoryTable } from './operation-history-table.js';

export interface OperationOrdersTabProps {
  operationId: string;
}

/**
 * Onglet « Commandes » d'une opération (`02` §10) : les commandes auxquelles
 * elle a été appliquée, leur export CSV, et le renvoi vers la liste Commandes
 * filtrée sur cette opération.
 */
export function OperationOrdersTab({ operationId }: OperationOrdersTabProps): JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-2">
        <Link
          to="/commandes"
          search={{ page: 1, pageSize: DEFAULT_PAGE_SIZE, sortDir: 'desc', operationId }}
          className="rounded-sm text-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          Voir dans Commandes
        </Link>
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            downloadFromApi('/api/orders/export.csv', { operationId });
          }}
        >
          <Download aria-hidden="true" />
          Exporter CSV
        </Button>
      </div>
      {/* `DataTable` porte déjà son propre panneau : pas de section encadrée autour. */}
      <OperationHistoryTable operationId={operationId} />
    </div>
  );
}
